import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const RolesReadSlice = createSlice({
  name: "RolesReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    RolesRead: (state) => {
      state.isLoading = true;
    },
    successRolesRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureRolesRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearRolesRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  RolesRead,
  successRolesRead,
  failureRolesRead,
  clearRolesRead,
} = RolesReadSlice.actions;

export default RolesReadSlice.reducer;
